import { FaCompressArrowsAlt, FaExpandArrowsAlt } from 'react-icons/fa'
import { DefaultTooltip as Tooltip } from '../../Tooltip'

const ExpandToggleButton = ({
    isExpanded,
    onToggle,
    className = '',
    tooltipId,
}) => {
    return (
        <div
            className={`field has-text-right ${className}`}
            style={{ marginBottom: '1rem' }}
        >
            <span
                onClick={onToggle}
                style={{ cursor: 'pointer', padding: '0.25rem' }}
                data-tooltip-content={isExpanded ? 'Collapse' : 'Expand to Full Screen'}
                data-tooltip-id={tooltipId}
            >
                {isExpanded ? <FaCompressArrowsAlt /> : <FaExpandArrowsAlt />}
            </span>
            <Tooltip id={tooltipId} place="top" stayOpen={false} />
        </div>
    )
}

export default ExpandToggleButton
